import axios from "axios";
import JobBatchesOrderList from "./JobBatchesOrderList";

export default class JobBatchesOrderListCommand{

    jobOrders : JobBatchesOrderList[];
    totalPages: number;
    totalCount : number;

    constructor()
    {
      this.jobOrders=[];
      this.totalPages=0;
      this.totalCount=0;
    }

    async loadbatchOrders(pageNumber: any, pageSize: any, jobid:any, jobbatchid:any, status: any,filterid:any) {
      try {
          const API_URL = process.env.REACT_APP_API_URL
          const idToken : string | null = localStorage.getItem("IdToken");
          const response = await axios.get(`${API_URL}/v1/jobs/${jobid}/jobbatches/${jobbatchid}/orders`, {
              params: {
                  page: pageNumber,
                  pageSize: pageSize,
                  status:status,
                  filterid:filterid
              },
              headers:{
                  'Authorization': `${idToken}`
              }
          });

          const data = response.data.response.items;
          this.jobOrders = data;
          this.totalPages = response.data.response.totalPages
          this.totalCount=response.data.response.totalCount
      } catch (error) {
          console.error('Failed to load job batches data:', error);
      }
  }
}